import React from 'react';
import './LoadingSpinner.css';

const LoadingSpinner = ({ 
  size = 'medium', 
  color = 'blue', 
  text = 'Loading...',
  overlay = false 
}) => {
  const spinnerClass = `loading-spinner ${size} ${color}`;
  
  if (overlay) {
    return (
      <div className="spinner-overlay">
        <div className={spinnerClass}>
          <div className="spinner"></div>
          {text && <p className="spinner-text">{text}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className={spinnerClass}>
      <div className="spinner"></div>
      {text && <p className="spinner-text">{text}</p>}
    </div>
  );
};

export default LoadingSpinner;